import { useEffect } from "react";

const useDocumentTitle = (title) => {
    useEffect(() => {
        document.title = `${title} | Dev Hire`;
    }, [title]);
}

export default useDocumentTitle;